/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_ResidentialInputs */

const en_val_residential = /** @type {(inputs: Val_ResidentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Residential`)
};

const es_val_residential = /** @type {(inputs: Val_ResidentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Residencial`)
};

const fr_val_residential = /** @type {(inputs: Val_ResidentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Résidentiel`)
};

const de_val_residential = /** @type {(inputs: Val_ResidentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wohnimmobilie`)
};

const ja_val_residential = /** @type {(inputs: Val_ResidentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`居住用`)
};

const zh_val_residential = /** @type {(inputs: Val_ResidentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`住宅`)
};

const ar_val_residential = /** @type {(inputs: Val_ResidentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سكني`)
};

const id_val_residential = /** @type {(inputs: Val_ResidentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Residensial`)
};

const it_val_residential = /** @type {(inputs: Val_ResidentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Residenziale`)
};

const ru_val_residential = /** @type {(inputs: Val_ResidentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Жилая недвижимость`)
};

const pt_val_residential = /** @type {(inputs: Val_ResidentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Residencial`)
};

const ko_val_residential = /** @type {(inputs: Val_ResidentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주거용`)
};

/**
* | output |
* | --- |
* | "Residential" |
*
* @param {Val_ResidentialInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_residential = /** @type {((inputs?: Val_ResidentialInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_ResidentialInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_residential(inputs)
	if (locale === "es") return es_val_residential(inputs)
	if (locale === "fr") return fr_val_residential(inputs)
	if (locale === "de") return de_val_residential(inputs)
	if (locale === "ja") return ja_val_residential(inputs)
	if (locale === "zh") return zh_val_residential(inputs)
	if (locale === "ar") return ar_val_residential(inputs)
	if (locale === "id") return id_val_residential(inputs)
	if (locale === "it") return it_val_residential(inputs)
	if (locale === "ru") return ru_val_residential(inputs)
	if (locale === "pt") return pt_val_residential(inputs)
	return ko_val_residential(inputs)
});